export default "__VITE_ASSET__BC4ENET7__"